// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"a85ffb6d","232":"6ce3b57e","599":"08e966a2"}[chunkId] + ".chunk.js";
};